module.exports = __webpack_public_path__ + "static/media/art21.f68b6965.jpg";